import React, { useEffect, useState } from "react";
import { Accordion, Button, Col, Form, Row, Table } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import { MdDateRange, MdOutlineRefresh } from "react-icons/md";
import Select from "react-select";
import { formatDate, formatTime } from "Helper/Converters";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Formik } from "formik";

import ReasonAPIs from "../../APIs/reason";
import TicketAPIs from "../../APIs/ticket";
import StationCodesAPIs from "../../APIs/station-code";
import TicketTypesAPIs from "../../APIs/ticket-types";
import AuthAPIs from "../../APIs/auth";
import FileAPIs from "../../APIs/file";

import { useSelector } from "react-redux";
import axios from "axios";
import { ENDPOINT } from "config/constants";
import { AiOutlineSave } from "react-icons/ai";
import { FiDelete } from "react-icons/fi";
import CustomDatePicker from "Components/CustomDatePicker";
import moment from "moment";
import { Modal } from "react-bootstrap";

const AccordionsSection = ({ ticketData }) => {
  const [ticketLogs, setTicketLogs] = useState([]);
  const [ticketFiles, setTicketFiles] = useState([]);
  const [officeClearInfo, setOfficeClearInfo] = useState([]);
  const [preCompleteInfo, setPreCompleteInfo] = useState([]);
  const [users, setUsers] = useState([]);
  const [usersAll, setUsersAll] = useState([]);
  const [operationReasons, setOperationReasons] = useState([]);
  const [operationReason, setOperationReason] = useState("");
  const [operationComment, setOperationComment] = useState("");
  const [operationSpeakTo, setOperationSpeakTo] = useState("");
  const [operationEmail, setOperationEmail] = useState("");
  const [stationCodes, setStationCodes] = useState([]);
  const [ticketTypes, setTicketTypes] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [event, setEvent] = useState(null);

  const [showUnitsModal, setShowUnitsModal] = useState(false);
  const [unitsModalJson, setUnitsModalJson] = useState(null);

  const openUnitsModal = (unitsObj) => {
    setUnitsModalJson(unitsObj || {});
    setShowUnitsModal(true);
  };

  const closeUnitsModal = () => {
    setShowUnitsModal(false);
    setUnitsModalJson(null);
  };

  // safe numeric display: backend is returning strings like "0"
  const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const handleFileChange = (event) => {
    setSelectedFile(event?.target?.files[0]);
    setEvent(event);
  };

  const user = useSelector((state) => state.auth);
  const userId = user.userId;

  //  ADDED: permissions list from redux (adjust path if your store differs)
  const permissions = user?.department?.permissions || [];

  //  ADDED: permission flag
  const canViewAssignedDetails = Array.isArray(permissions)
    ? permissions.includes("view_ticket_assigned_details")
    : false;

  const utilityOfficeClears =
    ticketData?.detail?.ticketUtilityOfficeClears ?? [];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "44px",
    }),
  };

  const [selectedUser, setSelectedUser] = useState();
  const [selectedUserName, setSelectedUserName] = useState();

  const [endDate, setEndDate] = useState(new Date());
  const [rescheduleDate, setRescheduleDate] = useState(new Date());
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  const [deleteFileLoader, setDeleteFileLoader] = useState(false);

  const FileUploadComponent = () => {
    return (
      <div className="d-flex align-items-center justify-content-between w-100">
        <label htmlFor="fileInput" className="btn btn-primary">
          Choose a file
        </label>
        <input
          type="file"
          id="fileInput"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        {selectedFile && (
          <span style={{ marginLeft: 10 }}>
            {selectedFile.type.startsWith("image") ? (
              <img
                style={{ height: 250, width: 250 }}
                src={URL.createObjectURL(selectedFile)}
              />
            ) : (
              selectedFile?.name
            )}
          </span>
        )}
        {/* <Button
          style={{ minWidth: "140px" }}
          onClick={handleUpload}
          disabled={uploadFileLoader}
        >
          {uploadFileLoader ? "Loading..." : "Upload"}
        </Button> */}
      </div>
    );
  };

  const handleReassign = async () => {
    if (!selectedUser) {
      toast.error("Please Select User to Assign");
      return;
    }
    if (!ticketData?.id) {
      toast.error("No Tickets Selected.");
      return;
    }

    const res = await TicketAPIs.assignReassignTicket({
      ticketId: [ticketData?.id],
      userId: selectedUser,
      type: "re_assign",
      reAssignDate: moment(endDate).format("YYYY-MM-DD"),
    });
    if (res) {
      toast.success("Ticket Assigned Successfully");
      getTicketLogs();
    }
  };

  const handleOperationLog = async () => {
    if (!selectedUser) {
      toast.error("Please Select User ");
      return;
    }
    if (!operationReason && !operationComment) {
      toast.error("Add Reason and Comment");
      return;
    }
    const remarks =
      operationReason === "Re-Scheduled"
        ? `Ticket rescheduled by ${selectedUserName}  for ${formatDate(
            rescheduleDate,
          )} after speaking with ${operationSpeakTo} - ${operationComment}`
        : `${operationReason} by ${selectedUserName} - ${operationComment}`;

    const res = await TicketAPIs.addTicketLog({
      ticketIds: [ticketData?.id],
      userId: selectedUser,
      action: "OPERATION_LOG",
      remarks: remarks,
    });

    if (operationReason === "Re-Scheduled") {
      // check if file is selected or not
      if (!selectedFile) {
        toast.error("Please select a file");
        return;
      }
      await handleUpload(event);
      await TicketAPIs.rescheduleTicket({
        ticketId: [ticketData?.id],
        rescheduleDate: moment(rescheduleDate).format("YYYY-MM-DD"),
        comment: operationComment,
        speaksWith: operationSpeakTo,
        rescheduleBy: `${user.user.firstName} ${user.user.lastName}`,
      });
    }
    if (res) {
      toast.success("Operation Log Added");
      getTicketLogs();
      setEvent(null);
      setSelectedFile(null);

      // setSelectedUser(null);
      setOperationComment("");
      // setOperationReason();
    }
  };

  const handleUpload = async (event) => {
    event?.preventDefault(); // Prevent default form submission behavior
    setUploadFileLoader(true);
    const formData = new FormData();
    formData.append("files", selectedFile);
    var bearer_token = localStorage.getItem("accessToken");
    //headers["Authorization"] = `Bearer ${bearer_token}
    try {
      // Replace 'YOUR_UPLOAD_API_ENDPOINT' with the actual API endpoint for file upload
      const response = await axios.post(
        `${ENDPOINT.tickets.uploadFile}/${ticketData?.id}/upload-files`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${bearer_token}`,
          },
        },
      );

      toast.success("File uploaded successfully");
      setSelectedFile(null);
      getTicketFiles();
    } catch (error) {
      toast.error(`File not uploaded: ${error.message}`);
    } finally {
      setUploadFileLoader(false);
    }
  };

  const deleteFile = async (id) => {
    setDeleteFileLoader(true);
    const res = await FileAPIs.deleteFile(id);
    if (res?.data?.success) {
      toast.success("File deleted successfully");
      getTicketFiles();
    }
    setDeleteFileLoader(false);
  };

  const getTicketLogs = async () => {
    if (ticketData?.id) {
      const tickets = await TicketAPIs.ticketLogs({
        ticketId: ticketData?.id,
      });

      if (tickets) {
        setTicketLogs(tickets.data.data);
      }
    }
  };

  const getTicketFiles = async () => {
    if (ticketData?.id) {
      const tickets = await TicketAPIs.ticketFiles({
        ticketId: [ticketData?.id],
      });

      if (tickets) {
        setTicketFiles(tickets.data.data);
      }
    }
  };

  const getOfficeClearData = async () => {
    if (ticketData?.id) {
      const tickets = await TicketAPIs.getOfficeClearStationCode(
        ticketData?.id,
      );

      if (tickets) {
        setOfficeClearInfo(tickets.data.data);
      }
    }
  };
  const getTicketPreCompleteData = async () => {
    if (ticketData?.id) {
      const tickets = await TicketAPIs.getTicketPreCompleteData(ticketData?.id);

      if (tickets) {
        setPreCompleteInfo(tickets.data.data);
      }
    }
  };

  const getUsers = async () => {
    const users = await AuthAPIs.getAllUsers();
    const customArr = [];
    const customArrAll = [];
    if (users) {
      users.data?.data?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
        // Only include active users and exclude current user
        if (item?.id !== userId && item?.isActive === true) {
          customArr.push(data);
        }
      });
      users.data?.data?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${
            item?.firstName == "System Admin" ? "System" : item?.firstName
          } ${item?.lastName}`,
        };
        // Only include active users for all users list
        if (item?.isActive === true) {
          customArrAll.push(data);
        }
      });
      customArr.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      setUsers([{ value: "", label: "Select" }, ...customArr]);
      setUsersAll([
        { value: "", label: "Select" },
        ...customArrAll?.sort((a, b) => {
          if (a.label.toLowerCase() < b.label.toLowerCase()) {
            return -1;
          }
          if (a.label.toLowerCase() > b.label.toLowerCase()) {
            return 1;
          }
          return 0;
        }),
      ]);
    }
  };

  const getAllReason = async () => {
    const types = await ReasonAPIs.getReason();

    const customArr = [];
    if (types) {
      const arr = [...types.data.data];
      arr?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${item?.name}`,
        };
        customArr.push(data);
      });
      setOperationReasons(customArr);
    }
  };

  const getAllStationCodes = async () => {
    const stationCodes = await StationCodesAPIs.getStationCode();

    const customArr = [];
    if (stationCodes) {
      const arr = [...stationCodes.data.data];
      arr?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${item?.name} `,
        };
        customArr.push(data);
      });
      setStationCodes(customArr.sort((a, b) => a.label.localeCompare(b.label)));
    }
  };

  const getAllTicketTypes = async () => {
    const types = await TicketTypesAPIs.getTicketType();

    const customArr = [];
    if (types) {
      const arr = [...types.data.data];
      arr?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${item?.name}`,
        };
        customArr.push(data);
      });
      setTicketTypes(customArr);
    }
  };

  useEffect(() => {
    if (!ticketData?.id) return;
    getTicketLogs();
    getUsers();
    getTicketFiles();
    getAllReason();
    getAllStationCodes();
    getAllTicketTypes();
    getOfficeClearData();
    getTicketPreCompleteData();
    const emailRegex =
      /(?:<)?([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:>)?/;
    const emailMatch = ticketData?.detail?.email?.match(emailRegex);
    if (emailMatch) {
      setOperationEmail(emailMatch[1]);
    } else {
      setOperationEmail(""); // or handle the case where the email is not valid
    }
  }, []);

  const validationSchema = Yup.object().shape({
    ticketType: Yup.string().required("Ticket Type. is required"),
    // additionalInfo: Yup.string().required("Additional Info is required"),
  });

  return (
    <Accordion defaultActiveKey="0" className="exclude-print">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Reassignment Log</Accordion.Header>
        <Accordion.Body>
          {/* <h6>Reassignment Logs</h6> */}
          {ticketLogs.length > 0 ? (
            ticketLogs
              .filter((obj) => obj.action === "TICKET_REASSIGN")
              .map((item) => {
                return (
                  <p>
                    {`Action: [${item?.action}] - Remarks: [${
                      item?.remarks
                    }] - Date: [${formatDate(
                      item?.createdAt,
                    )}] - Time: [${formatTime(item?.createdAt)}]`}
                  </p>
                );
              })
          ) : (
            <p>No data available!</p>
          )}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>Operations Log</Accordion.Header>
        <Accordion.Body>
          {ticketLogs.length > 0 ? (
            ticketLogs
              .filter((obj) => obj.action === "OPERATION_LOG")
              .map((item) => {
                return (
                  <p>
                    {`Action: [${item?.action}] - Remarks: [${
                      item?.remarks
                    }] - Date: [${formatDate(
                      item?.createdAt,
                    )}] - Time: [${formatTime(item?.createdAt)}]`}
                  </p>
                );
              })
          ) : (
            <p>No data available!</p>
          )}
        </Accordion.Body>
      </Accordion.Item>

      {permissions.includes("reassign_tickets") && (
        <Accordion.Item eventKey="2">
          <Accordion.Header>Reassign Tickets</Accordion.Header>
          <Accordion.Body>
            <Form>
              <Row>
                <div className="headingBox">
                  <h6>Reassign Tickets</h6>
                </div>
                <Col className="column">
                  <Form.Group className="form-group">
                    <Form.Label>Reassign To</Form.Label>
                    <Select
                      options={users}
                      styles={customStyles}
                      onChange={(selectedOption) => {
                        setSelectedUser(selectedOption.value);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col className="column">
                  <Form.Group className="form-group">
                    <Form.Label>Reassigned Date</Form.Label>
                    <div className="datepicker_box">
                      <CustomDatePicker
                        selected={endDate}
                        onSelect={(date) => setEndDate(date)}
                        dateFormat="MM/dd/yyyy"
                      />
                      <span>
                        <MdDateRange />
                      </span>
                    </div>
                  </Form.Group>
                </Col>

                <Col className="mb-4 column" style={{ maxWidth: "160px" }}>
                  <Button
                    style={{ minHeight: "44px", marginTop: "30px" }}
                    onClick={handleReassign}
                  >
                    <MdOutlineRefresh />
                    Reassign
                  </Button>
                </Col>
              </Row>
            </Form>
          </Accordion.Body>
        </Accordion.Item>
      )}

      <Accordion.Item eventKey="3">
        <Accordion.Header>Edit Ticket</Accordion.Header>
        <Accordion.Body>
          <Formik
            onSubmit={async (values) => {
              // submitHandler(values);

              let prevData = {
                contractorName: ticketData?.contractorName,
                primaryContact: ticketData?.primaryContact,
                email: ticketData?.email,
                dueDate: ticketData?.dueDate,
                dueTime: ticketData?.dueTime,
                locationLat: ticketData?.locationLat,
                locationLng: ticketData?.locationLng,
                nearestInteraction: ticketData?.nearestInteraction,
                city: ticketData?.city,
                typeOfWork: ticketData?.typeOfWork,
                workDoneFor: ticketData?.workDoneFor,
                workDepth: ticketData?.workDepth,
              };

              const mergedObject = { ...prevData, ...values };

              const res = await TicketAPIs.editTicket(
                ticketData?.id,
                mergedObject,
              );
              // const res = await TicketAPIs.updateTicket(
              //   ticketData?.id,
              //   mergedObject
              // );
              if (res) {
                toast.success("Ticket Updated Successfully.");
              }
            }}
            enableReinitialize
            initialValues={{
              //ticketType: "",
              ticketType: ticketData?.ticketType || "",
              //additionalInfo: ticketData?.additionalInfo,
              additionalInfo: ticketData?.detail?.additionalInfo || "",
              //region: "",
              region: ticketData?.detail?.region || "",
              stationCodeIds: [],
            }}
            validationSchema={validationSchema}
            validateOnChange={false}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              errors,
              setFieldValue,
            }) => (
              <Form
                className="dashboard-form mb-4"
                noValidate
                onSubmit={handleSubmit}
              >
                <Form.Group className="form-group">
                  <Form.Label>Locatebase Region</Form.Label>
                  <Form.Control
                    type="text"
                    name={"region"}
                    onChange={handleChange}
                    value={values.region}
                    required
                    isInvalid={!!errors.region}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>Station Code</Form.Label>
                  <Row>
                    <Col xs={9} md={10}>
                      <Select
                        isMulti
                        name={"stationCodeIds"}
                        options={stationCodes}
                        styles={customStyles}
                        onChange={(selectedOptions) => {
                          setFieldValue(
                            "stationCodeIds",
                            selectedOptions.map((option) => option.value),
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>Ticket Type</Form.Label>
                  <Select
                    name={"ticketType"}
                    options={ticketTypes}
                    styles={customStyles}
                    onChange={(selectedOptions) => {
                      setFieldValue("ticketType", selectedOptions.label);
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {/* {errors.ticketType} */}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>Add Info</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Additional Info..."
                    as={"textarea"}
                    rows={3}
                    name={"additionalInfo"}
                    onChange={handleChange}
                    value={values.additionalInfo}
                    required
                    isInvalid={!!errors.additionalInfo}
                  />
                </Form.Group>
                <Button type={"submit"}>
                  <AiOutlineSave />
                  Save
                </Button>
              </Form>
            )}
          </Formik>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4">
        <Accordion.Header>Add Operations Log</Accordion.Header>
        <Accordion.Body>
          <Form>
            <div className="d-flex align-items-center mb-3">
              <p className="me-3"> Total Number:</p>
              <span style={{ color: "#757575" }}>{ticketData?.ticketNo}</span>
            </div>
            <Form.Group className="form-group">
              <Form.Label>Specific User</Form.Label>
              <Select
                options={usersAll}
                styles={customStyles}
                onChange={(selectedOption) => {
                  setSelectedUser(selectedOption.value);
                  setSelectedUserName(selectedOption.label);
                }}
              />
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Label>Specific Reason</Form.Label>
              <Select
                options={operationReasons}
                styles={customStyles}
                onChange={(selectedOptions) => {
                  setOperationReason(selectedOptions.label);
                  setOperationComment(
                    selectedOptions.label == "Re-Scheduled"
                      ? "Ticket Re-Scheduled"
                      : "",
                  );
                }}
              />
            </Form.Group>

            {operationReason === "Re-Scheduled" && (
              <Row>
                <Col className="column" md={3}>
                  <Form.Group className="form-group mb-0">
                    <Form.Label>Reschedule Date</Form.Label>
                    <div className="datepicker_box">
                      <CustomDatePicker
                        selected={rescheduleDate}
                        onSelect={(date) => setRescheduleDate(date)}
                        dateFormat="MM/dd/yyyy"
                      />
                      <span>
                        <MdDateRange />
                      </span>
                    </div>
                  </Form.Group>
                </Col>
                <Col className="column" md={3}>
                  <Form.Group className="form-group">
                    <Form.Label>Who did you speak with ?</Form.Label>
                    <Form.Control
                      type="text"
                      value={operationSpeakTo}
                      onChange={(evt) => {
                        setOperationSpeakTo(evt?.currentTarget?.value);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col className="column" md={3}>
                  <Form.Group className="form-group">
                    <Form.Label> Email a re-schedule notice to</Form.Label>
                    <Form.Control
                      type="text"
                      value={operationEmail}
                      onChange={(evt) => {
                        setOperationEmail(evt?.currentTarget?.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            <Form.Group className="form-group">
              <Form.Label>Comments</Form.Label>
              <Form.Control
                type="number"
                as={"textarea"}
                rows={3}
                value={operationComment}
                onChange={(evt) => {
                  setOperationComment(evt.currentTarget.value);
                }}
              />
            </Form.Group>
            {operationReason === "Re-Scheduled" && <FileUploadComponent />}

            <Col className="mb-4 column" style={{ maxWidth: "160px" }}>
              <Button
                style={{ minHeight: "44px", marginTop: "30px" }}
                onClick={handleOperationLog}
              >
                Add Log
              </Button>
            </Col>
          </Form>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header>Office Clear Info</Accordion.Header>
        <Accordion.Body>
          {officeClearInfo.length > 0 && (
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Station Code</th>
                  {/* ✅ ADDED: only show User column if permission exists */}
                  {canViewAssignedDetails && <th>User</th>}
                  {/* <th>User</th> */}
                  <th>Is Office Cleared</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {officeClearInfo.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {
                        item.stationCode
                          ?.name /* Assuming this is the correct property */
                      }
                    </td>
                    {/* ✅ ADDED: only show User cell if permission exists */}
                    {canViewAssignedDetails && (
                      <td>{item.user?.firstName || "-"}</td>
                    )}
                    {/* <td>
                      {
                        item.user
                          ?.firstName  
                          // Assuming you have a user property 
                      }
                    </td> */}
                    <td>{item.isOfficeCleared ? "Yes" : "No"}</td>
                    <td>{`${formatDate(item.createdAt)} - ${formatTime(
                      item.createdAt,
                    )}`}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          {utilityOfficeClears.length > 0 && (
            <>
              <h6
                className={`mb-2 ${officeClearInfo.length > 0 ? "mt-3" : ""}`}
              >
                Utility office clear
              </h6>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>Station Code</th>
                    <th>Utility</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {utilityOfficeClears.map((item) => (
                    <tr key={item.id}>
                      <td>{item.stationCode}</td>
                      <td>{item.utilityType}</td>
                      <td>{item.status}</td>
                      <td>{`${formatDate(item.createdAt)} - ${formatTime(
                        item.createdAt,
                      )}`}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}

          {officeClearInfo.length === 0 && utilityOfficeClears.length === 0 && (
            <p>No data available!</p>
          )}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="7">
        <Accordion.Header>Pre-Complete Info</Accordion.Header>
        <Accordion.Body>
          {preCompleteInfo.length > 0 ? (
            <div style={{ overflowX: "auto", width: "100%" }}>
              {/*
                Keep <th> and <td> perfectly aligned by deriving both
                from the same column definition list.
              */}
              {(() => {
                const singleColumns = [
                  { key: "bramptonStormUnit", label: "Brampton Storm Unit" },
                  { key: "electricalUnit", label: "Electrical Unit" },
                  { key: "peelStormUnit", label: "Peel Storm Unit" },
                  { key: "resurfaced", label: "Resurfaced", raw: true },
                  {
                    key: "driveWayCurbox",
                    label: "Drive Way Curbox",
                    raw: true,
                  },

                  // RW fields
                  { key: "rwCLWaterUnit", label: "RW CL Water Unit" },
                  { key: "rwCLSanitaryUnit", label: "RW CL Sanitary Unit" },
                  { key: "rwCLStormUnit", label: "RW CL Storm Unit" },
                  { key: "rwMKWaterUnit", label: "RW MK Water Unit" },
                  { key: "rwMKSanitaryUnit", label: "RW MK Sanitary Unit" },
                  { key: "rwMKStormUnit", label: "RW MK Storm Unit" },
                  { key: "rwWorkArea", label: "RW Work Area" },
                ];

                const groupedUtilities = [
                  {
                    base: "waterUnit",
                    label: "Water Unit",
                    clear: "waterUnitClear",
                    additional: "waterUnitAdditional",
                  },
                  {
                    base: "sanitaryUnit",
                    label: "Sanitary Unit",
                    clear: "sanitaryUnitClear",
                    additional: "sanitaryUnitAdditional",
                  },
                  {
                    base: "sewerUnit",
                    label: "Sewer Unit",
                    clear: "sewerUnitClear",
                    additional: "sewerUnitAdditional",
                  },
                  {
                    base: "gasUnit",
                    label: "Gas Unit",
                    clear: "gasUnitClear",
                    additional: "gasUnitAdditional",
                  },
                  {
                    base: "hydroUnit",
                    label: "Hydro Unit",
                    clear: "hydroUnitClear",
                    additional: "hydroUnitAdditional",
                  },
                  {
                    base: "telecomUnit",
                    label: "Telecom Unit",
                    clear: "telecomUnitClear",
                    additional: "telecomUnitAdditional",
                  },
                  {
                    base: "catvUnit",
                    label: "CATV Unit",
                    clear: "catvUnitClear",
                    additional: "catvUnitAdditional",
                  },
                  {
                    base: "otherUnit",
                    label: "Other Unit",
                    clear: "otherUnitClear",
                    additional: "otherUnitAdditional",
                  },
                  {
                    base: "streetLightUnit",
                    label: "Street Light Unit",
                    clear: "streetLightUnitClear",
                    additional: "streetLightUnitAdditional",
                  },
                  {
                    base: "trafficLightUnit",
                    label: "Traffic Light Unit",
                    clear: "trafficLightUnitClear",
                    additional: "trafficLightUnitAdditional",
                  },
                  {
                    base: "zumUnit",
                    label: "Zum Unit",
                    clear: "zumUnitClear",
                    additional: "zumUnitAdditional",
                  },
                  {
                    base: "stormUnit",
                    label: "Storm Unit",
                    clear: "stormUnitClear",
                    additional: "stormUnitAdditional",
                  },
                  {
                    base: "fiberUnit",
                    label: "Fiber Unit",
                    clear: "fiberUnitClear",
                    additional: "fiberUnitAdditional",
                  },
                  {
                    base: "waterwasteUnit",
                    label: "Waterwaste Unit",
                    clear: "waterwasteUnitClear",
                    additional: "waterwasteUnitAdditional",
                  },
                  {
                    base: "trafficSignalUnit",
                    label: "Traffic Signal Unit",
                    clear: "trafficSignalUnitClear",
                    additional: "trafficSignalUnitAdditional",
                  },
                  {
                    base: "trafficComUnit",
                    label: "Traffic Com Unit",
                    clear: "trafficComUnitClear",
                    additional: "trafficComUnitAdditional",
                  },
                  // Halton Hills storm fields are capitalized in the data model here
                  {
                    base: "HHStormUnit",
                    label: "HH Storm Unit",
                    clear: "HHStormUnitClear",
                    additional: "HHStormUnitAdditional",
                  },
                ];

                const utilityColumns = groupedUtilities.flatMap((u) => [
                  { key: u.base, label: u.label },
                  { key: u.clear, label: `${u.label} Clear` },
                  { key: u.additional, label: `${u.label} Additional` },
                ]);

                const columns = [
                  { key: "fieldMarking", label: "Field Marking", raw: true },
                  { key: "locateVoid", label: "Locate Void", raw: true },
                  {
                    key: "cautionMessage",
                    label: "Caution Message",
                    raw: true,
                  },
                  {
                    key: "locatorComments",
                    label: "Locator Comments",
                    raw: true,
                  },
                  ...singleColumns,
                  ...utilityColumns,
                  { key: "__units__", label: "Units", raw: true },
                  ...(canViewAssignedDetails
                    ? [{ key: "__user__", label: "User", raw: true }]
                    : []),
                  { key: "__date__", label: "Date", raw: true },
                ];

                return (
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        {columns.map((col) => (
                          <th key={col.key}>{col.label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[...preCompleteInfo]
                        .sort((a, b) => {
                          const aTime = a?.createdAt
                            ? new Date(a.createdAt).getTime()
                            : 0;
                          const bTime = b?.createdAt
                            ? new Date(b.createdAt).getTime()
                            : 0;
                          return bTime - aTime; // newest first
                        })
                        .map((item, index) => (
                          <tr key={index}>
                            {columns.map((col) => {
                              if (col.key === "__units__") {
                                return (
                                  <td key={col.key}>
                                    {item?.units ? (
                                      <Button
                                        variant="link"
                                        style={{ padding: 0 }}
                                        onClick={() =>
                                          openUnitsModal(item.units)
                                        }
                                      >
                                        View
                                      </Button>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                );
                              }

                              if (col.key === "__user__") {
                                return (
                                  <td key={col.key}>
                                    {item.user?.firstName || "-"}
                                  </td>
                                );
                              }

                              if (col.key === "__date__") {
                                return (
                                  <td key={col.key}>
                                    {item?.finishedDate
                                      ? `${formatDate(item.finishedDate)} - ${formatTime(
                                          item.finishedDate,
                                        )}`
                                      : `${formatDate(item.createdAt)} - ${formatTime(
                                          item.createdAt,
                                        )}`}
                                  </td>
                                );
                              }

                              if (col.raw) {
                                return (
                                  <td key={col.key}>
                                    {item?.[col.key] ?? "-"}
                                  </td>
                                );
                              }

                              return (
                                <td key={col.key}>{num(item?.[col.key])}</td>
                              );
                            })}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                );
              })()}
              {/* Units Modal */}
              <Modal
                show={showUnitsModal}
                onHide={closeUnitsModal}
                size="lg"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Units</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                    {JSON.stringify(unitsModalJson, null, 2)}
                  </pre>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={closeUnitsModal}>Close</Button>
                </Modal.Footer>
              </Modal>
            </div>
          ) : (
            <p>No data available!</p>
          )}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header>Add Files</Accordion.Header>
        <Accordion.Body>
          <Form>
            <Col className="mb-4 column">
              <FileUploadComponent />
            </Col>
            {selectedFile && (
              <Button
                style={{ minWidth: "140px", marginBottom: "20px" }}
                onClick={handleUpload}
                disabled={uploadFileLoader}
              >
                {uploadFileLoader ? "Loading..." : "Upload"}
              </Button>
            )}
          </Form>
          {ticketFiles.length > 0 ? (
            ticketFiles.map((item) => {
              return (
                <div>
                  <a
                    href={`${item?.presignedUrl}`}
                    onClick={async () => {
                      // alert(JSON.stringify(item,null,2))
                      const response = await TicketAPIs.addLog({
                        ticketIds: [ticketData?.id],
                        userId,
                        action: "TICKET_IMAGE_DOWNLOADED",
                        remarks: `IMAGE : /${item.name} has been downloaded Successfully! by ${user.user?.firstName}`,
                      });
                    }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item?.name}
                  </a>
                  <FiDelete
                    size={17}
                    onClick={() => deleteFile(item?.id)}
                    className="ms-2"
                    style={{ color: "red", cursor: "pointer" }}
                  />
                </div>
              );
            })
          ) : (
            <p>No data available!</p>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default AccordionsSection;
